module.exports = __webpack_public_path__ + "static/media/logosinfondo.7c2a8540.png";